import { FC } from 'react'
import { News } from '@/root/shared-types'
import { Notifications } from '@/root/modules/tuuleliinid'
import { ContentContainer } from '@/root/ui/tuuleliinid'

interface NewsPageProps {
  news: News[]
}
export const NewsPage: FC<NewsPageProps> = ({ news }) => {
  return (
    <ContentContainer className="pt-28">
      <Notifications news={news} />
    </ContentContainer>
  )
}
